import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Stack,
} from "@chakra-ui/react";
import { AppLink, CtaButton, RichText } from "@/components";
import { BRAND_LABEL, HOME_PATH, NAV_ACTIONS, media, type NavItem } from "@/content";

type NavDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  items: readonly NavItem[];
  activeId: string | null;
};

export const NavDrawer = ({ isOpen, onClose, items, activeId }: NavDrawerProps) => (
  <Drawer isOpen={isOpen} onClose={onClose} placement="top">
    <DrawerOverlay />
    <DrawerContent bg="surface.DEFAULT" borderBottomRadius="md" pb="12px">
      <DrawerHeader px="pad" py="18px">
        <AppLink href={HOME_PATH} aria-label={BRAND_LABEL} display="inline-block" onClick={onClose}>
          <img
            src={media("variant3d-logo.png")}
            alt="VARIANT3D"
            width={447}
            height={76}
            style={{ height: 18, width: "auto", filter: "invert(1)" }}
          />
        </AppLink>
      </DrawerHeader>
      <DrawerCloseButton minW="44px" minH="44px" top="14px" right="12px" />

      <DrawerBody px="pad" pb="12px">
        <Stack spacing="4px">
          {items.map((item) => (
            <AppLink
              key={item.id}
              href={item.href}
              variant="nav"
              onClick={onClose}
              aria-current={activeId === item.id ? (item.kind === "route" ? "page" : "true") : undefined}
              display="flex"
              alignItems="center"
              minH="44px"
              px="12px"
              fontSize="1.25rem"
              textTransform="uppercase"
              borderRadius="sm"
              _hover={{ bg: "blackAlpha.50", color: "ink.DEFAULT" }}
            >
              <RichText nodes={item.label} />
            </AppLink>
          ))}
          {NAV_ACTIONS.map((action) => (
            <CtaButton
              key={action.label}
              href={action.href}
              variant={action.variant}
              mt="8px"
              w="100%"
              onClick={onClose}
            >
              {action.label}
            </CtaButton>
          ))}
        </Stack>
      </DrawerBody>
    </DrawerContent>
  </Drawer>
);
